/**
 * The last row of a Home sidebar section: the section's overview page (All
 * apps, All spaces), a plain row so it is found without hovering.
 *
 * @module components/home/HomeSidebarOverviewRow
 */
import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { SidebarMenuItem } from "../ui/sidebar";
import { SidebarRow } from "../ui/sidebar-row";

export function HomeSidebarOverviewRow({
  to,
  org,
  icon,
  label,
  isActive,
  onNavigate,
}: {
  readonly to: "/$org/spaces" | "/$org/apps";
  readonly org: string;
  readonly icon: ReactNode;
  readonly label: string;
  readonly isActive: boolean;
  readonly onNavigate: () => void;
}) {
  return (
    <SidebarMenuItem>
      <SidebarRow
        isActive={isActive}
        data-home-overview={to}
        render={<Link to={to} params={{ org }} onClick={onNavigate} />}
      >
        {icon}
        <span className="min-w-0 flex-1 truncate">{label}</span>
      </SidebarRow>
    </SidebarMenuItem>
  );
}
